import { AnchorHTMLAttributes, ReactNode } from 'react';
import Link, { LinkProps } from 'next/link';
import type { AmplienceLinkType } from '@/types/amplience';

type BaseProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> &
  Pick<LinkProps, 'prefetch'>;
type AmplienceLinkProps = BaseProps & {
  link: AmplienceLinkType;
  children: ReactNode;
};

const isInternalLink = (url: string) => {
  return url.startsWith('https://www.spreadshirt');
};

export const rewriteLinkIfNeeded = (url: string) => {
  if (isInternalLink(url)) {
    return typeof window === 'undefined'
      ? url.replace('https://www.spreadshirt', `https://${process.env.SUBDOMAIN}.spreadshirt`)
      : url.replace('https://www.spreadshirt', `https://${window.__subdomain}.spreadshirt`);
  }

  return url;
};

export default function AmplienceLink({
  link,
  className,
  children,
  prefetch,
  ...rest
}: AmplienceLinkProps) {
  const linkProps = link.openInNewTab
    ? {
        target: '_blank',
        rel: 'noopener noreferrer',
      }
    : {};
  return (
    <Link
      href={rewriteLinkIfNeeded(link.url)}
      className={className}
      data-tracking={link?.tracking}
      prefetch={prefetch ?? false}
      {...linkProps}
      {...rest}
    >
      {children}
    </Link>
  );
}
